import { AuthLayout } from '../../layout';
import { Register } from '../../features/register';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';

const RegisterPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.REGISTER}>
    <AuthLayout>
      <Register />
    </AuthLayout>
  </PageHelmet>
);

export default RegisterPage;
